import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';

import { useVote } from './hooks/useVote';
import { useGetParams } from './hooks/useGetParams';
import { testWords } from './data';

import { Advt } from './components/Advt/Advt';
import { WordCloudWraper } from './components/WordCloudWraper/WordCloudWraper';
import { Song } from './components/Song/Song';

function App() {
  const { demo, minFontWords, maxFontWords } = useGetParams();
  const { currentState, voteState, isVisible, idVote } = useVote();

  const options = useMemo(() => {
    return {
      colors: ['#ffffff', '#C93E28', '#FF8F8F', '#FFDA99'],
      enableTooltip: false,
      deterministic: true,
      fontFamily: 'mont',
      fontSizes: [minFontWords, maxFontWords],
      fontStyle: 'normal',
      fontWeight: 'bold',
      padding: 10,
      rotations: 3,
      rotationAngles: [0, 0],
      scale: 'sqrt',
      spiral: 'rectangular',
      transitionDuration: 500,
    };
  }, [minFontWords, maxFontWords]);

  const wordsNew = useMemo(() => {
    const res = {};
    voteState?.vars?.forEach((item, index) => {
      const word = item.comment.trim().toUpperCase();
      if (res[word]) {
        res[word].value = Number(item.count);
      } else {
        res[word] = {
          key: index,
          value: Number(item.count),
        };
      }
    });
    return Object.entries(res)
      .map((val) => ({
        text: val[0],
        value: val[1].value,
        key: val[1].key,
      }))
      .sort((a, b) => a.key - b.key)
      .filter((variant) => variant?.value !== 0);
  }, [voteState]);

  const countVote = useMemo(() => {
    return wordsNew?.reduce((acc, el) => acc + el?.value, 0) || 0;
  }, [wordsNew]);

  const wordsInTitre = useMemo(() => {
    return demo ? testWords : wordsNew;
  }, [countVote, demo, currentState, idVote]);

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className="motionBlock"
            key={`advt-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            className="motionBlock"
            key={`msg-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <WordCloudWraper
              wordsInTitre={wordsInTitre}
              options={options}
              currentState={currentState}
            />
          </motion.div>
        )}

        {/* {currentState === 'S3' && (
          <motion.div
            className="motionBlock"
            key="msgList"
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Song />
          </motion.div>
        )} */}
      </AnimatePresence>
    </div>
  );
}

export default App;
